/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/
import { AdobeId } from "reducers/CurrentUserReducer";

export enum WebsocketConnectionState {
  CONNECTING = "connecting",
  CONNECTED = "connected",
  DISCONNECTED = "disconnected",
}

// enum for: type RTCPeerConnectionState = "closed" | "connected" | "connecting" | "disconnected" | "failed" | "new";
export enum WebRTCConnectionState {
  CLOSED = "closed",
  CONNECTED = "connected",
  CONNECTING = "connecting",
  DISCONNECTED = "disconnected",
  FAILED = "failed",
  NEW = "new",
}

export interface Participant {
  muted: boolean;
  adobeId: AdobeId;
  chosenName?: string;
  displayName: string;
  webRtcConnectionState: WebRTCConnectionState;
  streamActive: boolean;
  websocketConnectionState: WebsocketConnectionState;
  micSamples: Array<number>;
}

export type ParticipantSet = Record<AdobeId, Participant>;
